export default "__VITE_ASSET__2ad81543__"